<template>

    <div>

        <app-head :title="supplier.name" />

        <div class="bg-light text-dark py-5 position-relative">
            <div class="container py-5">
                <div class="row align-items-center g-5">
                    <div class="col-md-5">
                        <img src="/img/logos/3m.svg" alt="3M" loading="lazy" class="img-fluid" style="min-width: 100%;">
                    </div>
                    <div class="col-md-7">
                        <div class="h2 fw-light">
                            Wenn es um globale Herausforderungen geht, <br>vertrauen Menschen auf die Wissenschaft
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container my-5">

            <div class="row row-cols-lg-3 g-5">
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/9a78b178-e95d-49d8-909a-d4f29a0ef666/SIBG_PSD_ProductAdvisors_L0_Thumbnail_410x270.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-9a78b178-e95d-49d8-909a-d4f29a0ef666-nB1dVpV" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">Der einfache Weg, das richtige Produkt zu finden.</h4>
                            Benötigen Sie Beratung bei der Auswahl des richtigen Produktes? Nutzen Sie unseren Produktberater, um die richtige Wahl zu treffen.
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/355931a7-5e85-4208-a35a-1afe9816ade1/licensed-rf-stock-asset-from-getty-id-185939128.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-355931a7-5e85-4208-a35a-1afe9816ade1-nCCtxKh" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">Nachhaltigkeit bei 3M</h4>
                            Die COVID-19-Pandemie hat den Fokus auf Klimaschutz und soziale Verantwortung gelenkt. Um ökologisch nachhaltiger zu werden, sind erhebliche Veränderungen notwendig. Lesen Sie hier, wie 3M mit dem Thema umgeht.
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/a51f3ecf-e149-414f-a198-05b0424492c3/banner-produktkatalog.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-a51f3ecf-e149-414f-a198-05b0424492c3-nD25R-t" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">3M Produktkatalog</h4>
                            Sind Sie auf der Suche nach einem bestimmten 3M Produkt? Hier gelangen Sie zur Auswahl. Wir freuen uns auf Ihre Bewertung.
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="container text-center py-5">
            <h2 class="display-5 fw-light">Über 3M</h2>
            <div class="lead">
                3M nutzt sein wissenschaftliches Know-how, um leistungsfähige Technologien zu entwickeln und die Lebensqualität eines jeden Einzelnen zu verbessern. Das Unternehmen setzt hierbei auf eine Unternehmenskultur, die ein kreatives Miteinander fördert. 3M erwirtschaftet mit seinen weltweit ca. 95.000 Beschäftigten einen Umsatz von 35,4 Mrd. US-Dollar und hat Niederlassungen in über 70 Ländern. 
            </div>
        </div>

        <div class="container my-5">

            <div class="row row-cols-lg-3 g-5">
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/9a78b178-e95d-49d8-909a-d4f29a0ef666/SIBG_PSD_ProductAdvisors_L0_Thumbnail_410x270.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-9a78b178-e95d-49d8-909a-d4f29a0ef666-nB1dVpV" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">Der einfache Weg, das richtige Produkt zu finden.</h4>
                            Benötigen Sie Beratung bei der Auswahl des richtigen Produktes? Nutzen Sie unseren Produktberater, um die richtige Wahl zu treffen.
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/355931a7-5e85-4208-a35a-1afe9816ade1/licensed-rf-stock-asset-from-getty-id-185939128.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-355931a7-5e85-4208-a35a-1afe9816ade1-nCCtxKh" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">Nachhaltigkeit bei 3M</h4>
                            Die COVID-19-Pandemie hat den Fokus auf Klimaschutz und soziale Verantwortung gelenkt. Um ökologisch nachhaltiger zu werden, sind erhebliche Veränderungen notwendig. Lesen Sie hier, wie 3M mit dem Thema umgeht.
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <img src="https://www.3mdeutschland.de/wps/wcm/connect/a51f3ecf-e149-414f-a198-05b0424492c3/banner-produktkatalog.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-a51f3ecf-e149-414f-a198-05b0424492c3-nD25R-t" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 class="card-title">3M Produktkatalog</h4>
                            Sind Sie auf der Suche nach einem bestimmten 3M Produkt? Hier gelangen Sie zur Auswahl. Wir freuen uns auf Ihre Bewertung.
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Filters from '@/shared/Filters';
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    import SupplierDetails from './SupplierDetails';

    export default {
        props: [
            'filters',
            'supplier',
            'products',
            'isFavoriteSupplier',
        ],
        components: {
            Results,
            Filters,
            Pagination,
            Breadcrumbs,
            ProductList,
            SupplierDetails,
        }
    }
</script>